<template>
  <div class="toogle-categories" @click="handleToggleCategoriesVisibility">
    <span v-if="!isClosed" class="toogle-categories__percent">
      {{ percentage | formatPercentage }}
    </span>

    <span class="toogle-categories__text" :class="{ 'toogle-categories__text--small': !isClosed }">
      <span v-if="!isClosed" v-html="$t(`${namespace}.otherCategories`)" />
      <span v-else>{{ $t(`${namespace}.hide`) }}</span>
    </span>

    <v-icon class="toogle-categories__icon autocomplete__arrow" color="primary" right>
      {{ isClosed ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </v-icon>
  </div>
</template>

<script>
export default {
  name: 'CategoriesAction',
  props: {
    isClosed: {
      type: Boolean
    },
    percentage: {
      type: Number
    }
  },
  data () {
    return {
      namespace: 'Components.Performance'
    }
  },
  methods: {
    handleToggleCategoriesVisibility () {
      this.$emit('toggleVisibility')
    }
  }
}
</script>

<style lang="scss" scoped>
.toogle-categories {
  align-items: center;
  background-color: $white;
  border: 1px solid $gray-3;
  border-radius: 16px;
  color: var(--gray-7);
  cursor: pointer;
  display: inline-flex;
  height: 32px;
  padding: 0 8px;
  position: relative;
}

.toogle-categories__percent {
  color: $gray-7 !important;
  font-family: $title-font;
  font-weight: 700;
}

.toogle-categories__text {
  line-height: 1;
  margin-left: 7px;

  &.toogle-categories__text--small {
    font-size: 10px;
  }
}

.toogle-categories__icon {
  margin-left: 7px;
}
</style>
